import { UserPrivileges } from '../../../shared/providers';
import { EDRIntegration } from './IntegrationsConstants';

export const hasAnyEDRIntegrationEnabledForTenant = (
  tenant: string,
  privileges: Record<string, UserPrivileges>,
) => {
  const tenantPrivileges = privileges[tenant];
  return Object.values(EDRIntegration).some(
    (integration) => tenantPrivileges?.[integration],
  );
};
